import React, { useState } from 'react';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';

function ChangePassword({ onPasswordChanged }) {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Die neuen Passwörter stimmen nicht überein.');
      return;
    }

    setLoading(true);
    try {
      await axios.post('/api/users/me/change-password', {
        old_password: oldPassword,
        new_password: newPassword,
      });
      if (onPasswordChanged) onPasswordChanged();
      window.location.href = '/admin/edit';
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (Array.isArray(detail)) {
        setError(detail.map(d => d.msg).join(', '));
      } else {
        setError(detail || 'Passwortänderung fehlgeschlagen.');
      }
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 460, margin: '60px auto', padding: '0 16px' }}>
      <div className="card">
        <div style={{
          background: 'var(--warning-bg, #fff3cd)',
          border: '1px solid var(--warning-border, #ffc107)',
          borderRadius: 8,
          padding: '12px 16px',
          marginBottom: 24,
          color: 'var(--warning-text, #856404)',
        }}>
          <strong>Initiales Passwort ändern</strong>
          <p style={{ margin: '4px 0 0', fontSize: 14 }}>
            Bitte legen Sie ein persönliches Passwort fest, bevor Sie fortfahren.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Aktuelles Passwort</label>
            <input
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>

          <div className="form-group">
            <label>Neues Passwort</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              autoComplete="new-password"
            />
          </div>

          <div className="form-group">
            <label>Neues Passwort bestätigen</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              autoComplete="new-password"
            />
          </div>

          <p style={{ fontSize: 13, color: 'var(--text-muted, #666)', marginBottom: 16 }}>
            Mindestens 8 Zeichen, Groß- und Kleinbuchstaben sowie eine Ziffer.
          </p>

          <button type="submit" disabled={loading} style={{ width: '100%' }}>
            {loading ? 'Wird gespeichert…' : 'Passwort speichern'}
          </button>
        </form>

        {error && (
          <p style={{ color: 'salmon', marginTop: 12, fontSize: 14 }}>{error}</p>
        )}
      </div>
    </div>
  );
}

export default ChangePassword;
